export const movies = [
  {
    id: "mv1",
    title: "星海归途",
    category: "movie",
    genre: "科幻 / 冒险",
    region: "华语",
    year: 2025,
    rating: 9.1,
    duration: "148分钟",
    releaseDate: "2025-09-28",
    director: "陆亦舟",
    cast: ["沈砚", "温子涵", "顾清野"],
    tags: ["太空", "硬科幻", "亲情"],
    summary:
      "一场跨越三十年的星际漂流，让失联的探测器重新传回信号。工程师沈砚带着父亲未完成的心愿升空，在浩瀚星海中寻找人类回家的方向。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20movie%20poster%20artwork%20of%20a%20lone%20astronaut%20standing%20before%20a%20giant%20glowing%20blue%20planet%20deep%20navy%20space%20filled%20with%20stars%20teal%20and%20warm%20orange%20rim%20lighting%20epic%20mysterious%20mood%20ultra%20detailed%20digital%20illustration%20vertical%20clean%20cinematic&width=480&height=720&seq=cover-mv1&orientation=portrait",
    hot: 9820,
    updatedAt: "2025-09-28",
    badge: "独播",
  },
  {
    id: "mv2",
    title: "长夜无声",
    category: "movie",
    genre: "犯罪 / 悬疑",
    region: "欧美",
    year: 2024,
    rating: 8.7,
    duration: "126分钟",
    releaseDate: "2024-11-15",
    director: "Ethan Cole",
    cast: ["Marcus Reed", "Lena Voss", "Daniel Hart"],
    tags: ["雨夜", "追凶", "反转"],
    summary:
      "连续七个雨夜，城市边缘总会出现一具无声的尸体。退休探员被迫重返岗位，在蛛丝马迹中拼凑出一个被掩盖多年的真相。",
    cover:
      "https://readdy.ai/api/search-image?query=noir%20crime%20thriller%20movie%20poster%20of%20a%20rainy%20night%20city%20street%20with%20a%20lone%20silhouette%20under%20a%20streetlamp%20reflections%20on%20wet%20asphalt%20deep%20blue%20and%20amber%20contrast%20moody%20atmospheric%20cinematic%20vertical%20composition%20high%20detail%20no%20text&width=480&height=720&seq=cover-mv2&orientation=portrait",
    hot: 8340,
    updatedAt: "2024-11-15",
  },
  {
    id: "mv3",
    title: "山海拾光",
    category: "movie",
    genre: "剧情 / 家庭",
    region: "华语",
    year: 2025,
    rating: 9.0,
    duration: "132分钟",
    releaseDate: "2025-05-20",
    director: "苏晚晴",
    cast: ["周岚", "郑一舟", "小演员 奶酪"],
    tags: ["治愈", "亲情", "海边"],
    summary:
      "母亲去世后，叛逆少年被迫回到海边小镇，与沉默的外公一同生活。一间旧照相馆、一盒未冲洗的胶卷，让他重新理解了家与时光。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20family%20drama%20film%20poster%20of%20a%20boy%20and%20his%20grandfather%20walking%20along%20a%20seaside%20pier%20at%20golden%20sunset%20soft%20warm%20orange%20light%20gentle%20nostalgic%20mood%20painterly%20illustration%20vertical%20cinematic%20composition%20with%20plenty%20of%20sky%20no%20text&width=480&height=720&seq=cover-mv3&orientation=portrait",
    hot: 7960,
    updatedAt: "2025-05-20",
    badge: "口碑",
  },
  {
    id: "mv4",
    title: "逆风飞行",
    category: "movie",
    genre: "励志 / 剧情",
    region: "华语",
    year: 2024,
    rating: 8.5,
    duration: "118分钟",
    releaseDate: "2024-08-09",
    director: "何向东",
    cast: ["林逐", "许安然", "孟航"],
    tags: ["热血", "成长", "蓝天"],
    summary:
      "出身小镇的飞行学员一次次被淘汰，却始终不愿放弃驾驶舱里的那片天空。一次意外任务，让他证明了自己飞行的意义。",
    cover:
      "https://readdy.ai/api/search-image?query=inspirational%20drama%20movie%20poster%20of%20a%20young%20pilot%20looking%20up%20at%20a%20vast%20dramatic%20sky%20with%20sunbeams%20breaking%20through%20clouds%20wind%20blown%20courageous%20hopeful%20mood%20clean%20modern%20illustration%20vertical%20composition%20high%20detail%20no%20text&width=480&height=720&seq=cover-mv4&orientation=portrait",
    hot: 6890,
    updatedAt: "2024-08-09",
  },
  {
    id: "mv5",
    title: "雾城谜案",
    category: "movie",
    genre: "悬疑 / 推理",
    region: "日韩",
    year: 2023,
    rating: 8.8,
    duration: "121分钟",
    releaseDate: "2023-12-01",
    director: "Kaito Mori",
    cast: ["Sora Aoki", "Ren Takahashi", "Mio Nakamura"],
    tags: ["密室", "推理", "雾"],
    summary:
      "一座被浓雾封锁了三天的小城，一起找不到凶器的密室命案。年轻的推理作家与老刑警合作，在雾气散去前锁定真凶。",
    cover:
      "https://readdy.ai/api/search-image?query=mystery%20detective%20movie%20poster%20of%20an%20empty%20foggy%20narrow%20old%20town%20street%20with%20dim%20glowing%20lanterns%20dense%20gray%20mist%20a%20distant%20lone%20figure%20cold%20teal%20and%20faint%20orange%20accents%20tense%20atmospheric%20cinematic%20vertical%20composition%20no%20text&width=480&height=720&seq=cover-mv5&orientation=portrait",
    hot: 9010,
    updatedAt: "2023-12-01",
  },
  {
    id: "mv6",
    title: "春日列车",
    category: "movie",
    genre: "爱情 / 剧情",
    region: "日韩",
    year: 2025,
    rating: 8.6,
    duration: "110分钟",
    releaseDate: "2025-03-14",
    director: "Yuna Sato",
    cast: ["Haru Kimura", "Aoi Fujimoto", "Kenji Ito"],
    tags: ["青春", "初恋", "樱花"],
    summary:
      "每年春天同一趟列车，两个人总会不期而遇。七次擦肩而过之后，他们终于在同一站下车，却发现彼此早已改变。",
    cover:
      "https://readdy.ai/api/search-image?query=romantic%20drama%20movie%20poster%20of%20a%20young%20couple%20standing%20on%20a%20train%20platform%20surrounded%20by%20falling%20cherry%20blossoms%20soft%20pink%20petals%20warm%20spring%20sunlight%20tender%20nostalgic%20mood%20delicate%20painterly%20illustration%20vertical%20composition%20no%20text&width=480&height=720&seq=cover-mv6&orientation=portrait",
    hot: 7120,
    updatedAt: "2025-03-14",
  },
  {
    id: "mv7",
    title: "铁血边界",
    category: "movie",
    genre: "动作 / 战争",
    region: "欧美",
    year: 2024,
    rating: 8.4,
    duration: "140分钟",
    releaseDate: "2024-06-21",
    director: "Rafael Stone",
    cast: ["Logan Price", "Ivan Krug", "Mia Torres"],
    tags: ["硬核", "突围", "兄弟情"],
    summary:
      "边境哨所被切断补给与通讯，一支六人小队必须在援军抵达前守住阵地。弹尽粮绝之际，他们守的不只是防线。",
    cover:
      "https://readdy.ai/api/search-image?query=action%20war%20movie%20poster%20of%20soldiers%20silhouetted%20against%20a%20smoky%20orange%20explosion%20sunset%20in%20a%20desert%20dust%20orange%20and%20charcoal%20tones%20gritty%20tense%20dramatic%20cinematic%20vertical%20composition%20high%20detail%20no%20text&width=480&height=720&seq=cover-mv7&orientation=portrait",
    hot: 8570,
    updatedAt: "2024-06-21",
  },
  {
    id: "mv8",
    title: "深海信号",
    category: "movie",
    genre: "科幻 / 惊悚",
    region: "欧美",
    year: 2025,
    rating: 8.9,
    duration: "134分钟",
    releaseDate: "2025-10-02",
    director: "Nora Vance",
    cast: ["Owen Blake", "Priya Nair", "Tom Halsey"],
    tags: ["深海", "未知", "惊悚"],
    summary:
      "万米海沟深处，科研潜艇接收到一段规律的低频信号。当信号开始回应他们的动作，船员们意识到，海底并不只有他们。",
    cover:
      "https://readdy.ai/api/search-image?query=deep%20sea%20science%20fiction%20thriller%20movie%20poster%20of%20a%20submarine%20descending%20into%20dark%20abyssal%20ocean%20with%20a%20faint%20bioluminescent%20glow%20in%20the%20depths%20deep%20navy%20and%20teal%20tones%20ominous%20mysterious%20atmosphere%20vertical%20cinematic%20composition%20no%20text&width=480&height=720&seq=cover-mv8&orientation=portrait",
    hot: 9340,
    updatedAt: "2025-10-02",
    badge: "新上线",
  },
];